import React from 'react';

/**
 * Critical Care Switcher component
 */
const CriticalCareSwitcher = (props) => (
  <div>
    <div className="nppe2-fc-critical-care-switcher nppe2-fc-check-box">
      <label>
        <input
          name="nppe2-fc-critical-care"
          type="checkbox"
          checked={props.selected}
          onChange={(e) => props.onSelect(e.target.checked)}
          disabled = {(props.selectedWeightAdjustment)? "disabled" : ""}
        />
        <div className="nppe2-fc-check-box__label">
          {props.data.label}
        </div>

        {props.selected && props.selectedDiagnoses.length===0 &&
          <p className="nppe2-fc-help-critical-care">{props.data.help}</p>
        }
      </label>

    </div>

    <div className="nppe2-fc-critical-care-switcher nppe2-fc-check-box">
      <label>
        <input
          name="nppe2-fc-critical-care"
          type="checkbox"
          checked={props.selectedAnorexia}
          onChange={(e) => props.onSelectAnorexia(e.target.checked)}
          disabled = {!props.selected}
        />
        <div className="nppe2-fc-check-box__label">
          {props.data.anorexiaLabel}
        </div>
      </label>
    </div>

  </div>
);

export default CriticalCareSwitcher;
